module.exports = __webpack_public_path__ + "static/media/events.3d357414.svg";